<div class="footer-text">
  <p class="paragraph-m-medium">{{ 'FOOTER.ACCIONA' | translate }}</p>
  <a
    acSecondaryLink
    negative
    href="{{ this._countrySig() === 'ES' ? _footerConstants.acciona : _footerConstants.solutionsPt }}"
    target="_blank"
    rel="noreferrer noopener"
  >
    {{ 'FOOTER.LINKS.ACCIONA' | translate }}
    <ac-icon name="external-link" size="small"></ac-icon>
  </a>
</div>
<div class="footer-links">
  <div class="acciona-links">
    <h1 class="label mb-1 text-secondary-medium-light">{{ 'FOOTER.MORE_ACCIONA' | translate }}</h1>
    <a acSecondaryLink negative href="{{ _footerConstants.we }}" target="_blank" rel="noreferrer noopener">
      {{ 'FOOTER.LINKS.WE' | translate }}
      <ac-icon name="external-link" size="small"></ac-icon>
    </a>
    <a
      acSecondaryLink
      negative
      href="{{ this._countrySig() === 'ES' ? _footerConstants.solutions : _footerConstants.solutionsPt }}"
      target="_blank"
      rel="noreferrer noopener"
    >
      {{ 'FOOTER.LINKS.SOLUTIONS' | translate }}
      <ac-icon name="external-link" size="small"></ac-icon>
    </a>
    <a acSecondaryLink negative href="{{ _footerConstants.currentNews }}" target="_blank" rel="noreferrer noopener">
      {{ 'FOOTER.LINKS.CURRENT_NEWS' | translate }}
      <ac-icon name="external-link" size="small"></ac-icon>
    </a>
  </div>
  @if (_userSig() != null) {
    <div class="help-links">
      <h1 class="label mb-1 text-secondary-medium-light">{{ 'FOOTER.TITLE' | translate }}</h1>

      @if (_countrySig() === 'ES') {
        <a acSecondaryLink negative href="tel:{{ _spanishPhoneNumber }}">
          {{ 'FOOTER.LINKS.CALL' | translate: { number: _spanishPhoneNumber } }}
        </a>
      } @else {
        <a acSecondaryLink negative href="tel:{{ _portugueseComercialPhoneNumber }}">
          {{ 'HELP.LINKS.APOIO_CLIENTE' | translate }} ({{ 'HELP.LINKS.APOIO_CLIENTE_HOURS' | translate }})
        </a>
        <a acSecondaryLink negative href="tel:{{ _portugueseOutagesPhoneNumber }}">
          {{ 'HELP.LINKS.ASISTENCIA' | translate }}
        </a>
        <a acSecondaryLink negative href="tel:{{ _portugueseMeterReadingPhoneNumber }}">
          {{ 'HELP.LINKS.READINGS' | translate }}
        </a>
      }
      <a acSecondaryLink negative href="mailto:{{ _emailSig() }}" target="_blank" rel="noreferrer noopener">
        {{ 'FOOTER.LINKS.CONTACTUS' | translate }}
      </a>
    </div>
  }
</div>
